import { Navigate } from 'react-router-dom';

import useParentAuth from '../hooks/useParentAuth';
import { getLandingRouteForUser, isParentRole } from '../utils/auth';

const ParentProtectedRoute = ({ children }) => {
  const { user, isAuthenticated } = useParentAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/" replace />;
  }

  if (!isParentRole(user?.role)) {
    return <Navigate to={getLandingRouteForUser(user) || '/'} replace />;
  }

  return children;
};

export default ParentProtectedRoute;
